import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BuildingIntegrationComponent } from './building-integration.component'
import { CommonModule } from '@angular/common';
import { CardModule } from '../card/card.module';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule, ButtonModule, TableModule, SnackbarMessageModule, TooltipModule, ContextualMessageModule } from '@ngx-interact-ui/core';
import { LicensesService } from '../../services/licenses.service';
import { CertificatesModule } from '../certificates/certificates.module';

@NgModule({
  declarations: [BuildingIntegrationComponent],
  imports: [CommonModule,
    CardModule,
    TranslateModule,
    DialogModule,
    ButtonModule,
    TableModule,
    SnackbarMessageModule,
    TooltipModule,
    ContextualMessageModule,
    CertificatesModule
  ],
  exports: [BuildingIntegrationComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [LicensesService],
})
export class BuildingIntegrationModule { }